import React from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";

import DestinationMarker from "../../assets/img/destinationMarker";
import SourceMarker from "../../assets/img/sourceMarker";
import { selectMapLevel } from "../../redux/map/map.selectors";

import { MapCenterStyled } from "./MapCenter.styles";

const MapCenter = ({ selectMapLevel }) => {
  const mark = {
    width: 32,
    height: 38,
  };
  console.log(selectMapLevel);
  // debugger;
  // alert("dfs");
  return (
    <MapCenterStyled
      className="d-flex align-items-center justify-content-center position-absolute"
      markWidth={mark.width}
      markHeight={mark.height}
    >
      {selectMapLevel === 0 ? (
        <SourceMarker width={mark.width} height={mark.height} />
      ) : (
        <DestinationMarker width={mark.width} height={mark.height} />
      )}
    </MapCenterStyled>
  );
};

const mapStateToProps = createStructuredSelector({
  selectMapLevel: selectMapLevel,
});

export default connect(mapStateToProps)(MapCenter);
